import React from 'react'
import {KTSVG} from '../../helpers'

function TemplateListCard({data, description, handleEdit, handleRemove}: any) {
  return (
    <div className='px-8 py-8 d-lg-flex justify-content-between'>
      <div className='flex-grow-1  align-items-center justify-content-center w-85'>
        <h5 className='fs-4 fw-bold mb-2'>
          {data?.template_type === 1 ? 'Birthday Template' : 'Anniversary Template'}
        </h5>
        <span className='fs-4'>{description ? description : 'Description is missing .....'}</span>
      </div>

      <div className='flex-grow-0 d-flex align-items-center justify-content-center'>
        <div className='d-flex justify-content-end flex-shrink-0'>
          <button
            type='button'
            onClick={() => handleEdit(data)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
          >
            <KTSVG path='/media/icons/duotune/art/art005.svg' className='svg-icon-3' />
          </button>
          <button
            type='button'
            onClick={() => handleRemove(data?.id)}
            className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
          >
            <KTSVG path='/media/icons/duotune/general/gen027.svg' className='svg-icon-3' />
          </button>
        </div>
      </div>
    </div>
  )
}

export default TemplateListCard
